/**
 * Header Functionality Handlers
 *
 * @author Industry at Delete
 * @see    https://github.com/industryatdelete
 */
jQuery(document).ready(function($) {

    /*
     * @TODO
     */
    var mainHeader = $('#header'),
        body = $(document.body),
        headerHeight = mainHeader.height(),
        scrolling = false,
        previousTop = 0,
        currentTop = 0,
        scrollDelta = 10,
        scrollOffset = 150;

    /*
     * @TODO
     */
    $(window).on('scroll', function() {
        if (! scrolling) {
            scrolling = true;
            (! window.requestAnimationFrame) 
            ? setTimeout(autoHideHeader, 250)
            : requestAnimationFrame(autoHideHeader);
        }
    });
    

    /*
     * @TODO
     */
    $(window).on('resize', function() {
        headerHeight = mainHeader.height();
    });


    /*
     * @TODO
     */
    function autoHideHeader() {
        var currentTop = $(window).scrollTop();
        checkSimpleNavigation(currentTop);
        previousTop = currentTop;
        scrolling = false;
    }


    /*
     * @TODO
     */
    function checkSimpleNavigation(currentTop) {
        if (previousTop - currentTop > scrollDelta && !body.hasClass('scrolling')) {
            mainHeader.removeClass('is-hidden');
        } else if (currentTop - previousTop > scrollDelta && currentTop > scrollOffset) {
            mainHeader.addClass('is-hidden');
            if ($('#header-search').hasClass('is-visible')) {
                $('.search-trigger').trigger('click');
            }
        }

    }
});